import { logger } from "@nanostores/logger";

import { $assessment } from "./assessment";

logger({
  Assessment: $assessment,
});
